import clsx from 'clsx';
import { forwardRef } from 'react';

import { FormError } from '~/components/Form/Error/FormError';
import { HelpText } from '~/components/HelpText';
import { Label } from '~/components/Label';
import textareaStyles from './TextArea.module.css';
import type { TextareaProps } from './TextArea.types';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      id,
      name,
      label,
      helpText,
      disabled,
      required,
      labelVariant = 'small',
      rows = 4,
      errorMessage,
      rounded = false,
      ...props
    },
    ref
  ) => {
    const getDescriptors = () => (helpText ? `TextareaHelpText-${id}-help` : undefined);

    return (
      <div>
        {label && (
          <Label id={id} disabled={disabled} variant={labelVariant} required={required}>
            {label}
          </Label>
        )}
        <div className={textareaStyles.wrapper}>
          <textarea
            id={id}
            name={name}
            disabled={disabled}
            ref={ref}
            className={clsx(textareaStyles.field, rounded && textareaStyles.fieldRounded)}
            rows={rows}
            aria-describedby={getDescriptors()}
            data-test-id={`textarea-${id}`}
            {...props}
          />
        </div>
        {helpText && (
          <div className={textareaStyles.helpText}>
            <HelpText id={`TextareaHelpText-${id}`} disabled={disabled}>
              {helpText}
            </HelpText>
          </div>
        )}
        {errorMessage ? <FormError message={errorMessage} /> : null}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';
